// @flow

import React from 'react'
import Select, { Creatable } from 'react-select'
import { isString, find } from 'lodash'
import './OpinarySelect.css'

type Props = {
  value: string,
  onChange: Function,
  options: Array<Object>,
  placeholder?: string,
  disabled?: boolean,
  clearable?: boolean,
  creatable?: boolean,
  className?: string,
  colorClass?: string,
}

const OpinarySelect = ({
  value = '',
  onChange,
  options,
  placeholder = '',
  disabled = false,
  clearable = false,
  creatable = false,
  className = '',
  colorClass = '',
}: Props) => {
  const handleChange = option => {
    if (!option) {
      onChange(null)
    } else {
      onChange(option.value)
    }
  }

  const renderValue = option => (
    <span className={colorClass}>{option.label}</span>
  )

  const renderArrow = () => (
    <span className={`chevron chevron-bottom ${colorClass}`}></span>
  )

  const Component = creatable ? Creatable : Select

  const getOptions = () => {
    if (creatable && isString(value) && !find(options, { value: value })) {
      const tempOption = {
        label: value,
        value: value,
        className: 'Select-create-option-placeholder',
      }
      return [...options, tempOption]
    }
    return options
  }

  return (
    <Component
      className={`op-select ${className}`}
      value={value}
      placeholder={<span className={colorClass}>{placeholder}</span>}
      options={getOptions()}
      valueRenderer={renderValue}
      arrowRenderer={renderArrow}
      disabled={disabled}
      clearable={clearable}
      onChange={handleChange}
    />
  )
}

export default OpinarySelect



// WEBPACK FOOTER //
// ./src/components/Controls/OpinarySelect.js